// Component Name:  Charger Filter component
// Author: Bharath
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original
// Date:
// Description: Filter component interated in the charger page.
// Dependencies: React,  connectorsOptions, modelTypeOptions, powerRatingOptions,CheckBox
// Interfaces: Accepts props including selectedLocationId, locationSelected, email
// Maintenance History:  1.0 - First Version

// Edited by Lavanya S
// [✓] Removed manufacturer filter.
// [21-05-2025] Integrated custom CheckBox component.
// [23-04-2025] Updated addValue and removeValue functions to use setState,
//              ensuring UI re-renders correctly on check/uncheck actions.
// [23-04-2024] Integrated custom button
import React, { Component } from "react";
import { Collapse } from "reactstrap";
import { Link } from "react-router-dom";
import { connectorsOptions, modelTypeOptions, powerRatingOptions } from "../../pages/Utility/Constants";
import CheckBox from "../../pages/Utility/CheckBox";
import { ActiveBtn, CancelBtn } from "../../pages/Utility/Button";
import LKElectricityImg from "../../assets/images/LK_Icons/LK_Electricity.svg";
import LKConnectorsImg from "../../assets/images/LK_Icons/LK_Disconnection state.svg";
import LKLocationImg from "../../assets/images/LK_Icons/LK_Location Pin.svg";
import { resetChargerFilter, updateParamFilter } from "../../store/actions";
import { connect } from "react-redux";

/**
 * Props:
 *
 * @param {function} results - Callback function invoked when the "Apply" button is clicked.
 * @param {function} clearResults - Callback function used to clear all applied filters.
 */
class ChargerFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fData: this.props.paramFilter,
      // manufacturerAcc: false,
      typeAcc: false,
      powerAcc: false,
      connectorsAcc: false,
      locationAcc: false,
    };
  }
  // on component load param with applied filter will be expanded
  componentDidMount() {
    const { paramFilter } = this.props;
    console.log("chargerFilter: ", paramFilter);

    const ifAnyFilter = Object.keys(paramFilter).filter((item) => paramFilter[item]?.length > 0);
    if (ifAnyFilter.length > 0) {
      this.setState({
        typeAcc: ifAnyFilter.includes("Type"),
        powerAcc: ifAnyFilter.includes("rating"),
        connectorsAcc: ifAnyFilter.includes("connectors"),
        locationAcc: ifAnyFilter.includes("Location"),
      });
    }
  }

  handleApply = () => {
    this.props.updateParamFilter(this.state.fData);
    try {
      if (this.props.results !== null) this.props.results(this.state.fData);
    } catch (e) {
      console.log("Filter Results Error", e);
    }
  };

  // to clear reset the filters.
  // uncheck all the selected filter.
  // Close the accordian
  handleClear = () => {
    this.props.resetChargerFilter();
    this.setState(
      {
        fData: {
          // manufacturer: [],
          connectors: [],
          rating: [],
          Type: [],
          Location: [],
        },
        // manufacturerAcc: false,
        typeAcc: false,
        powerAcc: false,
        connectorsAcc: false,
        locationAcc: false,
      },

      () => {
        this.props.clearResults();
      }
    );
  };

  // to add the checked data in the fData
  addValue = (value) => {
    this.setState((prevState) => {
      const fData = { ...prevState.fData };

      if (!value) return null;

      if (value.connectors && !fData.connectors.includes(value.connectors)) {
        fData.connectors = [...fData.connectors, value.connectors].sort();
      }

      if (value.Type && !fData.Type.includes(value.Type)) {
        fData.Type = [...fData.Type, value.Type].sort();
      }

      if (value.rating && !fData.rating.includes(value.rating)) {
        fData.rating = [...fData.rating, value.rating].sort();
      }

      if (value?.Location && !fData?.Location?.includes(value?.Location)) {
        fData.Location = [...fData.Location, value.Location].sort();
      }
      return { fData };
    });
  };

  // to remove the unchecked data from the object
  removeValue = (value) => {
    this.setState((prevState) => {
      const fData = { ...prevState.fData };

      if (!value) return null;

      if (value.connectors) {
        fData.connectors = fData.connectors.filter((v) => v !== value.connectors);
      }

      if (value.Type) {
        fData.Type = fData.Type.filter((v) => v !== value.Type);
      }

      if (value.rating) {
        fData.rating = fData.rating.filter((v) => v !== value.rating);
      }

      if (value.Location) {
        fData.Location = fData.Location.filter((v) => v !== value.Location);
      }
      return { fData };
    });
  };

  render() {
    return (
      <React.Fragment>
        <h5 className="font-size-14 mb-3">Categories</h5>

        <div id="accordion" className="custom-accordion categories-accordion mb-3">
          {/* Type accordian */}
          <div className="categories-group-card">
            <Link
              to="#"
              className={this.state.typeAcc ? "categories-group-list accordian-bg-products" : "categories-group-list"}
              onClick={() => this.setState({ typeAcc: !this.state.typeAcc })}
            >
              <i style={{ color: "#005C8E" }} className="mdi mdi-current-dc font-size-8 align-middle mr-2"></i>
              Type
              <i
                style={{ color: "#005C8E" }}
                className={this.state.typeAcc === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}
              ></i>
            </Link>
            <Collapse isOpen={this.state.typeAcc} id="collapseTwo">
              <div>
                <ul className="list-unstyled categories-list mb-0">
                  {modelTypeOptions.map((type) => (
                    <div className="form-check mb-1" key={type.value}>
                      <CheckBox
                        label={type.value}
                        checked={this.state.fData?.Type?.includes(type.value)}
                        checkedData={(isNowChecked) => {
                          isNowChecked ? this.addValue({ Type: type.value }) : this.removeValue({ Type: type.value });
                        }}
                      />
                    </div>
                  ))}
                </ul>
              </div>
            </Collapse>
          </div>

          {/* Power accordian */}
          <div className="categories-group-card">
            <Link
              to="#"
              onClick={() => this.setState({ powerAcc: !this.state.powerAcc })}
              className={this.state.powerAcc ? "categories-group-list accordian-bg-products" : "categories-group-list"}
            >
              {/* <i className="mdi mdi-all-inclusive font-size-16 align-middle mr-2"></i> */}
              <img src={LKElectricityImg} alt="electricityImg" style={{ width: "16px", height: "16px", marginRight: "10px" }} />
              Power
              <i
                style={{ color: "#005C8E" }}
                className={this.state.powerAcc === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}
              ></i>
            </Link>
            <Collapse isOpen={this.state.powerAcc} id="collapseFour">
              <div>
                <ul className="list-unstyled categories-list mb-0">
                  {powerRatingOptions.map((rating) => (
                    <div className="form-check mb-1" key={rating.value}>
                      <CheckBox
                        label={rating.label}
                        checked={this.state.fData?.rating?.includes(rating.value)}
                        checkedData={(isNowChecked) => {
                          isNowChecked ? this.addValue({ rating: rating.value }) : this.removeValue({ rating: rating.value });
                        }}
                      />
                    </div>
                  ))}
                </ul>
              </div>
            </Collapse>
          </div>

          {/* Connectors accordian */}
          <div className="categories-group-card">
            <Link
              to="#"
              onClick={() => this.setState({ connectorsAcc: !this.state.connectorsAcc })}
              className={this.state.connectorsAcc ? "categories-group-list accordian-bg-products" : "categories-group-list"}
            >
              {/* <i className="mdi mdi-all-inclusive font-size-16 align-middle mr-2"></i> */}
              <img src={LKConnectorsImg} alt="connectorsImg" style={{ width: "16px", height: "16px", marginRight: "10px" }} />
              Connectors
              <i
                style={{ color: "#005C8E" }}
                className={this.state.connectorsAcc === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}
              ></i>
            </Link>
            <Collapse isOpen={this.state.connectorsAcc} id="collapseFour">
              <div>
                <ul className="list-unstyled categories-list mb-0">
                  {connectorsOptions.map((conn) => (
                    <div className="form-check mb-1" key={conn.value}>
                      <CheckBox
                        label={conn.label}
                        checked={this.state.fData?.connectors?.includes(conn.value)}
                        checkedData={(isNowChecked) => {
                          isNowChecked ? this.addValue({ connectors: conn.value }) : this.removeValue({ connectors: conn.value });
                        }}
                      />
                    </div>
                  ))}
                </ul>
              </div>
            </Collapse>
          </div>

          {/* Location accordian */}
          <div className="categories-group-card">
            <Link
              to="#"
              className={this.state.locationAcc ? "categories-group-list accordian-bg-products" : "categories-group-list"}
              onClick={() => this.setState({ locationAcc: !this.state.locationAcc })}
            >
              <img src={LKLocationImg} alt="connectorsImg" style={{ width: "16px", height: "16px", marginRight: "10px" }} /> Location
              <i
                style={{ color: "#005C8E" }}
                className={this.state.locationAcc === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}
              ></i>
            </Link>
            <Collapse isOpen={this.state.locationAcc} id="collapseTwo">
              <div>
                <ul className="list-unstyled categories-list mb-0" style={{ maxHeight: "400px", overflowY: "auto" }}>
                  {this.props.locationsData.map((location) => (
                    <div className="form-check mb-1" key={location.id}>
                      <CheckBox
                        label={location.name}
                        checked={this.state.fData?.Location?.includes(location.id)}
                        checkedData={(isNowChecked) => {
                          isNowChecked ? this.addValue({ Location: location.id }) : this.removeValue({ Location: location.id });
                        }}
                      />
                    </div>
                  ))}
                </ul>
              </div>
            </Collapse>
          </div>

          <div className="mt-2 text-center d-flex">
            <ActiveBtn name={"Apply"} handleClick={this.handleApply} />
            <CancelBtn name={"Clear"} handleClick={this.handleClear} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  const { param } = state.ChargerManagement.chargerFilter;
  const paramFilter = param;
  return { paramFilter };
};

const mapDispatchToProps = (dispatch) => ({
  updateParamFilter: (payload) => dispatch(updateParamFilter(payload)),
  resetChargerFilter: () => dispatch(resetChargerFilter()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChargerFilter);
